<template>
  <div class="home-ticket container-custom">
    <div class="home-ticket__title">PLAY</div>
    <div class="home-ticket__search-book">
      <div class="home-ticket__search">
        <input
          v-model="dataBookBet"
          class="form-control"
          placeholder="Book a Bet #"
        />
      </div>
      <div class="home-ticket__book">
        <button
            :class="{'home-ticket__book__loading': loadingBookTicket}"
            @click="handleBookTicket()"
        >
          <span class="home-ticket__book__loading__loader"></span>
          BOOK TICKET
        </button>
      </div>
    </div>
    <div class="home-ticket__filters">
      <div class="home-ticket__filters-button">
        <button @click="handleViewResults()">VIEW RESULTS</button>
      </div>
      <div class="home-ticket__filters-input">
        <input
            v-model="dataSearchLoto"
            class="form-control"
            placeholder="Search Lotto"
        />
      </div>
      <div class="home-ticket__filters-sort">
        <div class="home-ticket__filters-sort-by">
          <div class="dropdown">
            <button
                class="btn btn-secondary dropdown-toggle"
                type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            >
              Sort By
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a
                  v-for="(item, index) in dataDropdown"
                  :key="index"
                  @click="$emit('changeDropdown', index)"
                  class="dropdown-item"
                  :class="{ active: item.active }"
              >{{ item.title }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-ticket__list-tickets">
      {{checkExpired}}
      <div
          v-for="(item, index) in games"
          :key="index"
          @click="handleOpenItem(item)"
          class="home-ticket__item"
      >
        <div class="home-ticket__item-flag">
<!--          <img v-lazy="$store.state.baseAPIUrl + `/components/Betradar/img/flags-v2/${item.country_slug}.svg`" />-->
          <img :src="getBeerImage(item.country_slug)"/>
        </div>
        <div class="home-ticket__item-title">
          {{ item.name }}
        </div>
        <div class="home-ticket__item-time">
          <CountDownTimer
            :date="item.cutoff"
          />
        </div>
      </div>
    </div>
<!--    <div v-if="isLoadMore" class="home-ticket__loadmore">-->
<!--      <button @click="$emit('load-more')" class="home-ticket__loadmore-button">LOAD MORE</button>-->
<!--    </div>-->
  </div>
</template>

<script>
import $ from "jquery";
import CountDownTimer from '@/components/common/count-down-timer/CountDownTimer.vue';
import moment from "moment";
export default {
  components: {
    CountDownTimer
  },
  props: {
    bookBet: {
      type: String,
      default: ''
    },
    searchLoto: {
      type: String,
      default: ''
    },
    listGames: {
      type: Array,
      default: () => []
    },
    dataDropdown: {
      type: Array,
      default: () => []
    },
    totalPage: {
      type: Number,
      default: 30
    },
    isLoadMore: {
      type: Boolean,
      default: true
    },
    loadingBookTicket: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataSearchLoto: this.searchLoto,
      dataBookBet: this.bookBet,
      currentDate: Math.trunc(((new Date()).getTime() + ((new Date()).getTimezoneOffset() * 60000)) / 1000),
      requestCount: 1
    }
  },
  watch: {
    dataSearchLoto(val) {
      this.$emit('handleSearch', val)
    },
  },
  mounted(){
    window.setInterval(() => {
      this.currentDate = new Date();
    },1000);
  },
  computed: {
    games() {
      return this.listGames;
    },
    totalPageToShow() {
      return this.totalPage
    },
    checkExpired: function () {
      const now = this.currentDate;
      if (this.listGames) {
        for (let i = 0; i < this.listGames.length; i++) {
          const game = this.listGames[i];
          if (this.$filters.getDate(game.cutoff) <= now) {
            this.$emit('handleExpired')
          }
        }
      }
      return null
    },
  },
  methods: {
    getBeerImage(img) {
      try {
        return require(`@/assets/images/flags/${img}.png`)
      } catch (e) {
        return require("@/assets/images/flags/error.png")
      }
    },
    formatDateTime(time) {
      return moment(time, "yyyy-MM-dd HH:mm:ss").toDate();
    },
    handleOpenItem(item) {
      const params = { slug: item.slug, drawName: item.name };
      this.$store.dispatch('addParamsLuckyNumber', params);
      this.$router.push({ name: 'LuckyNumbers' });

    },
    handleBookTicket() {
      this.$emit('handleBookBet', this.dataBookBet)
    },
    handleViewResults() {
      this.$router.push('/results');
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/home/home.scss"/>
